import { render, staticRenderFns } from "./ApplicationOverview.vue?vue&type=template&id=489cb39c&scoped=true"
import script from "./ApplicationOverview.vue?vue&type=script&lang=js"
export * from "./ApplicationOverview.vue?vue&type=script&lang=js"
import style0 from "./ApplicationOverview.vue?vue&type=style&index=0&id=489cb39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489cb39c",
  null
  
)

export default component.exports